import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const API_BASE = "https://api.saidqodirxon.uz/api/admin";

function ProjectForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("admin-token");

  const [project, setProject] = useState({
    title: { en: "", uz: "" },
    description: { en: "", uz: "" },
    category: "Web Development",
    githubLink: "",
    liveLink: "",
    demoUrl: "",
    image: "",
    techStack: [],
    order: 0,
  });

  const [techInput, setTechInput] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (id) {
      fetchProject();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchProject = async () => {
    try {
      const res = await axios.get(`${API_BASE}/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const found = res.data.projects.find((p) => p._id === id);
      if (found) {
        // Support both imageUrl (old) and image (new) fields
        if (found.imageUrl && !found.image) {
          found.image = found.imageUrl;
        }
        setProject(found);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleImageUpload = async (file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);
    try {
      setUploading(true);
      const res = await axios.post(`${API_BASE}/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data.success) {
        setProject({
          ...project,
          image: `https://api.saidqodirxon.uz${res.data.url}`,
        });
      }
    } catch (err) {
      alert("Image upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE}/project`, project, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("Project saved successfully!");
      navigate("/admin");
    } catch (err) {
      alert("Error saving project: " + err.message);
    }
  };

  const addTech = () => {
    if (techInput.trim()) {
      setProject({
        ...project,
        techStack: [...(project.techStack || []), techInput.trim()],
      });
      setTechInput("");
    }
  };

  const removeTech = (index) => {
    setProject({
      ...project,
      techStack: project.techStack.filter((_, i) => i !== index),
    });
  };

  return (
    <div className="min-vh-100 bg-darker text-white py-5">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="purple fw-bold">
            {id ? "Edit Project" : "New Project"}
          </h2>
          <Button variant="outline-light" onClick={() => navigate("/admin")}>
            ← Back to Admin
          </Button>
        </div>

        <Card className="bg-dark-purple border-light-purple shadow-lg">
          <Card.Body className="p-5">
            <Form onSubmit={handleSubmit}>
              <Row className="gy-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Project Title (English)
                    </Form.Label>
                    <Form.Control
                      value={project.title.en}
                      onChange={(e) =>
                        setProject({
                          ...project,
                          title: { ...project.title, en: e.target.value },
                        })
                      }
                      className="admin-input-premium"
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Project Title (Uzbek)
                    </Form.Label>
                    <Form.Control
                      value={project.title.uz}
                      onChange={(e) =>
                        setProject({
                          ...project,
                          title: { ...project.title, uz: e.target.value },
                        })
                      }
                      className="admin-input-premium"
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Description (English)
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={project.description.en}
                      onChange={(e) =>
                        setProject({
                          ...project,
                          description: {
                            ...project.description,
                            en: e.target.value,
                          },
                        })
                      }
                      className="admin-input-premium"
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Description (Uzbek)
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={project.description.uz}
                      onChange={(e) =>
                        setProject({
                          ...project,
                          description: {
                            ...project.description,
                            uz: e.target.value,
                          },
                        })
                      }
                      className="admin-input-premium"
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Category
                    </Form.Label>
                    <Form.Select
                      value={project.category}
                      onChange={(e) =>
                        setProject({ ...project, category: e.target.value })
                      }
                      className="admin-input-premium"
                    >
                      <option value="Web Development">Web Development</option>
                      <option value="Mobile App">Mobile App</option>
                      <option value="CRM System">CRM System</option>
                      <option value="E-commerce">E-commerce</option>
                      <option value="Telegram Bot">Telegram Bot</option>
                      <option value="Portfolio">Portfolio</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Order
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={project.order}
                      onChange={(e) =>
                        setProject({
                          ...project,
                          order: parseInt(e.target.value) || 0,
                        })
                      }
                      className="admin-input-premium"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      GitHub Link
                    </Form.Label>
                    <Form.Control
                      type="url"
                      value={project.githubLink}
                      onChange={(e) =>
                        setProject({ ...project, githubLink: e.target.value })
                      }
                      className="admin-input-premium"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Live Demo Link
                    </Form.Label>
                    <Form.Control
                      type="url"
                      value={project.liveLink}
                      onChange={(e) =>
                        setProject({ ...project, liveLink: e.target.value })
                      }
                      className="admin-input-premium"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Demo Video URL
                    </Form.Label>
                    <Form.Control
                      type="url"
                      value={project.demoUrl}
                      onChange={(e) =>
                        setProject({ ...project, demoUrl: e.target.value })
                      }
                      placeholder="YouTube, Vimeo, etc."
                      className="admin-input-premium"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Project Image
                    </Form.Label>
                    <Form.Control
                      type="file"
                      onChange={(e) => handleImageUpload(e.target.files[0])}
                      className="admin-input-premium"
                      accept="image/*"
                    />
                    {uploading && (
                      <small className="text-info">Uploading...</small>
                    )}
                    {project.image && (
                      <img
                        src={project.image}
                        alt="Preview"
                        className="mt-3 rounded shadow"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "300px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Tech Stack
                    </Form.Label>
                    <div className="d-flex gap-2 mb-2">
                      <Form.Control
                        value={techInput}
                        onChange={(e) => setTechInput(e.target.value)}
                        onKeyPress={(e) =>
                          e.key === "Enter" && (e.preventDefault(), addTech())
                        }
                        placeholder="Add technology (e.g., React.js)"
                        className="admin-input-premium"
                      />
                      <Button onClick={addTech} variant="purple-premium">
                        Add
                      </Button>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      {project.techStack?.map((tech, idx) => (
                        <span key={idx} className="badge bg-purple px-3 py-2">
                          {tech}
                          <button
                            type="button"
                            onClick={() => removeTech(idx)}
                            className="btn-close btn-close-white ms-2"
                            style={{ fontSize: "10px" }}
                          />
                        </span>
                      ))}
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="text-purple fw-bold">
                      Display Order
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={project.order}
                      onChange={(e) =>
                        setProject({
                          ...project,
                          order: parseInt(e.target.value),
                        })
                      }
                      className="admin-input-premium"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="text-end mt-5">
                <Button
                  variant="outline-light"
                  className="me-3 px-4"
                  onClick={() => navigate("/admin")}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="purple-premium"
                  className="px-5 shadow"
                >
                  Save Project
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default ProjectForm;
